import { render, staticRenderFns } from "./RoleWeightListSetup.vue?vue&type=template&id=53e4314c&"
import script from "./RoleWeightListSetup.vue?vue&type=script&lang=js&"
export * from "./RoleWeightListSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports